export enum ModuleModeratorOptionsEnum {
  ADD_SECTION_ROUTE = 'add_section',
  ADD_PAGE_ROUTE = 'add_page'
}



// WEBPACK FOOTER //
// ./src/app/common/enums/module-moderator-options.enum.ts